<div id="logincallback">
    <div class="overlay"></div>
    <div class="main-pane" [ngClass]="{'active': isActive, 'fade-out': isFadeOut}">
        <div class="header">
            <div class="welcome">
                <img class="header-logo" src="../../assets/img/pros/pros-ai-color.png">
            </div>
        </div>
        <div class="main-content">
          <span class="uk-alert uk-alert-danger uk-margin-remove">Your account has been deactivated due to inactivity.
            Contact the <a href="https://connect.pros.com/user/login?destination=/" target="_blank">Support Desk</a> to regain access.</span>
        </div>
        <div class="button-panel">
          <button class="uk-button uk-button-primary back-button" (click)="backToLogin()">Back to Login</button>
        </div>
    </div>
</div>
